<template>
    <div class="firm-info">
        <h3 class="mb-1">
            {{ firm.name }}
        </h3>
        <csp-firm-infobox-details :firm="firm"/>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import FirmInfoBoxDetails from './FirmDetails';

    const loginStatus = Container.getInstance().getLoginStatusStore();

    export default {
        components: {
            'csp-firm-infobox-details': FirmInfoBoxDetails,
        },
        computed: {
            firm() {
                return loginStatus.getCurrentFirmAttributes();
            },
        },
    }
</script>
